import styled from 'styled-components';

export const StyledAddressIcon = styled.div`
  display: flex;

  & > div {
    display: inline-flex !important;
  }
`;
